export const portaledDropdownClassName = 'portaled-dropdown'
